import { useEffect, useState } from 'react';
import { Iasset2LangValue } from '../models';

const returnCurrentLangTranslationCode = (language: string) => {
  const table = {
    en: 'eng',
    de: 'deu',
  };
  return table[language as keyof typeof table];
};

export const useAssetCustomNameFieldsIndex = (customFields: Iasset2LangValue[] | null | undefined, currentLanguageCode: string) => {
  const [customNameIndex, setAssetCustomNameIndex] = useState<number>(0);
  useEffect(() => {
    if (!customFields) {
      setAssetCustomNameIndex(0);
      return;
    }
    // return the Index of the Object with the field lang === currentLanguageCode
    const index = customFields.findIndex((field) => field.lang === returnCurrentLangTranslationCode(currentLanguageCode));
    if (index === -1 && customFields.length === 0) {
      setAssetCustomNameIndex(0);
      return;
    }
    if (index === -1 && customFields.length !== 0) {
      setAssetCustomNameIndex(customFields.length);
      return;
    }
    setAssetCustomNameIndex(index);
  }, [customFields, currentLanguageCode]);

  return customNameIndex;
};
